<template>
  <div class="overflow">
    <div class="historyTable-container">
      <h2 class="title">{{ $t('tradingHistory.title')}}</h2>
      <!-- Resume Bar -->
      <!-- <div class="header">
        <div>
          <strong>Commision:</strong>
          {{ comissionTotalMt4 }}
        </div>
        <div>
          <strong>Swap:</strong>
          {{ swapTotal }}
        </div>
        <div>
          <strong>Profit/Loss:</strong>
          {{ profitLoss }}
        </div>
      </div>-->
      <!-- Filters -->
      <div class="cont-filters" style="margin-top: 40px;">
        <!-- filtro fechas -->
        <div>
          <label for="date">{{ $t('tradingHistory.from')}}</label>
          <input
            type="date"
            placeholder="Date From"
            id="date"
            v-model="dateFrom"
          />
        </div>
        <div>
          <label for="date_to">{{ $t('tradingHistory.to')}}</label>
          <input
            type="date"
            placeholder="Date To"
            id="date_to"
            v-model="dateTo"
          />
        </div>
        <!-- base on -->
        <div v-if="status_user == 'AT_DETAILS' || status_user == 'PENDING_VALIDATION'">
            <label for="date">*{{ $t('tradingHistory.type')}}</label>
            <CustomSelector 
              v-model="typeAccount" 
              :placeholder="this.$t('accountActivity.type')" 
              :options="typeAccountDemo">
            </CustomSelector>
          </div>
          <div v-else>
            <label for="date">*{{ $t('tradingHistory.type')}}</label>
            <CustomSelector 
              v-model="typeAccount" 
              :placeholder="this.$t('accountActivity.type')" 
              :options="typeAccounts">
            </CustomSelector>
          </div>
        <!-- platform -->
        <div>
          <label for="date">*{{ $t('tradingHistory.platform')}}</label>
          <CustomSelector
            v-model="platform"
            :placeholder="this.$t('accountActivity.platform')"
            :options="platforms"
          ></CustomSelector>
        </div>
        <!-- accounts -->
        <div v-if="platform === 'mt4' || platform === ''">
          <label for="date">{{ $t('tradingHistory.account')}}</label>
          <CustomSelector
            v-model="target"
            :placeholder="this.$t('accountActivity.placeholderAccount')"
            :options="targets"
          ></CustomSelector>
        </div>
        <div v-if="platform === 'mt5'">
          <label for="date">{{ $t('tradingHistory.account')}}</label>
          <CustomSelector
            v-model="target"
            :placeholder="this.$t('credit.trading')"
            :options="targets"
          ></CustomSelector>
        </div>
      </div>
      <button
      class="red-button"
      @click="getData"
      >{{ $t('tradingHistory.get')}}
    </button>
      <div class="table">
        <table>
          <tr>
            <th v-for="header in headers" :key="header">{{ header }}</th>
          </tr>
          <template v-for="row in paginatedData">
            <tr>
              <td v-for="(item, index) in row" :key="index">
                <span>{{ item }}</span>
              </td>
            </tr>
          </template>
        </table>
      </div>

      <!-- Link Navigation table -->
      <nav class="navigationTable" v-if="paginatedData.length > 0">
        <div>
          <label>{{ $t('tradingHistory.row')}}</label>
          <select v-model="elementsForPage" @change="reloadTable()">
            <option value="15">15</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="75">75</option>
            <option value="100">100</option>
          </select>
        </div>

        <ul class="pagination">
          <li class="page-item" @click="getPreviusPage()">
            <a class="page-link" href="#" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
          <li
            v-for="page in totalPagesNumber"
            :key="page"
            @click="getTable(page)"
            class="page-item"
            v-bind:class="isActive(page)"
          >
            <a class="page-link" href="#">{{ page }}</a>
          </li>
          <li class="page-item" @click="getNextPages()">
            <a class="page-link" href="#" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
      </nav>

      <button
        v-if="rows.length > 0"
        class="red-button"
        @click="generateCSV"
        :disabled="rows === null || rows.length === 0"
      >{{ $t('tradingHistory.download')}}</button>
      <button class="cabinet-back" @click="back">
        <div class="icon"></div>{{ $t('tradingHistory.back')}}
      </button>
    </div>
  </div>
  <Modal v-if="showDialog" @close="showDialog = false" dialogStyle="login-modal">
    <template #header>
      <h3>{{ $t('tradingHistory.confirm')}}</h3>
    </template>
    <template #body>
      <div>
        <p>{{ dialogMessage }}</p>
      </div>
    </template>
    <template #footer>
      <div>
        <button @click="showDialog = false">{{ $t('tradingHistory.close')}}</button>
      </div>
    </template>
  </Modal>
  <Preloader :showModal="showM"></Preloader>
</template>

<script>
import CustomSelector from "@/components/CustomSelector";
import Modal from "@/components/Modal";
import axios from "axios";
import { Logger } from "aws-amplify";
import store from "@/store"
import { getCurrentInstance, onMounted, onUnmounted, ref, watch } from "@vue/runtime-core";
import router from "../../router";
import Preloader from "@/components/Preloader";
import { i18n } from '@/plugins/i18n';


const logger = new Logger("main")

export default {
  name: "History",
  components: {
    CustomSelector,
    Modal,
    Preloader
  },
  setup() {
    let status_user = ref('')
    let showM = ref(false)
    let dialogMessage = ref('')
    let showDialog = ref(false)
    let targets = ref([])
    let dateFrom = ref(new Date())
    let dateTo = ref(new Date().toISOString().substr(0, 10))
    let platform = ref('')
    let platforms = ref([
      {
        value: 'mt4',
        text: 'MetaTrader 4'
      },
      {
        value: 'mt5',
        text: 'MetaTrader 5'
      }
    ])
    let based = ref(null)
    let basedOn = ref([
      {
        value: 'entry_time',
        text: 'Entry time'
      },
      {
        value: 'exit_time',
        text: 'Exit time'
      }
    ])
    let typeAccount = ref('')
    let typeAccounts = ref([
      {
        value: 'live',
        text: 'Live'
      },
      {
        value: 'demo',
        text: 'Demo'
      }
    ])
    let typeAccountDemo = ref([
      {
        value: 'demo',
        text: 'Demo'
      }
    ])
    let deposit = ref(0)
    let withdrawal = ref(0)
    let credit = ref(0)
    let commision = ref(0)
    let swap = ref(0)
    // let profitLoss = ref(0)
    // let comissionTotalMt4 = ref(0)
    // let swapTotal = ref(0)

    let accountsHistory = ref(null)
    let target = ref(null)
    let partialTrades1 = ref([])
    let partialTrades = ref([])
    let rows = ref([])
    let headers = ref([
      i18n.global.t('tradingHistory.deal'),
      i18n.global.t('tradingHistory.entryTime'),
      i18n.global.t('tradingHistory.typr'),
      i18n.global.t('tradingHistory.simbol'),
      i18n.global.t('tradingHistory.volume'),
      i18n.global.t('tradingHistory.entryPrice'),
      i18n.global.t('tradingHistory.sl'),
      i18n.global.t('tradingHistory.tp'),
      i18n.global.t('tradingHistory.exitTime'),
      i18n.global.t('tradingHistory.exitPrice'),
      i18n.global.t('tradingHistory.commision'),
      i18n.global.t('tradingHistory.swap'),
      i18n.global.t('tradingHistory.profit'),
    ])
    let paginatedData = ref([])
    let currentPage = ref(1)
    let elementsForPage = ref(15)
    let totalPagesNumber = ref(0)

    const internalInstance = getCurrentInstance()
    const emitter = internalInstance.appContext.config.globalProperties.emitter

    let userInfo;

    onMounted(() => {
      status_user.value = localStorage.getItem('activeAccount');
      showM.value = true
      let previousDate = new Date();
      previousDate.setMonth(previousDate.getMonth() - 1);
      dateFrom.value = previousDate.toISOString().substr(0, 10);
      emitter.on("userUpdated", () => {
        load()
      })
      // accounts()
      loadTable()
      load()
    })

    onUnmounted(() => {
      emitter.off("userUpdated")
    })

    const load = () => {
      if (!store.state.user) {
        return
      }
    }

    const reloadTable = () => {
      getDataPages(elementsForPage.value)
      loadTable()
    }

    const back = () => {
      router.go(-1)
    }

    const addTargetAccount = (accountValue, accountLabel) => {
      targets.value.push({
        value: accountValue,
        text: accountLabel
      })
    }

    const getData = () => {
      let valid =true

      let required = [
        typeAccount.value,
        platform.value,
        target.value
      ]

      for (let i = 0; i < required.length; i++) {
        if (required[i] === undefined || required[i] === null || required[i] === '' || required[i] === 0) {
          valid = false
        } else {
          valid = true
        }
      }

      /// validación campos no vacios
      if (!valid) {
        dialogMessage.value = this.$t('tradingHistory.error');
        showDialog.value = true;
        showM.value = false
        return false
      }
      loadTable()
    }

    const loadTable = () => {
      let accountTyp  = typeAccount.value == 'live' ?  '' : typeAccount.value;
      let typeAccountDL = '/' + platform.value+accountTyp +'accounthistory'
      let account_id = target.value
      let date_from = dateFrom.value
      let date_to = dateTo.value
      historyAccounst(account_id, date_from, date_to, typeAccountDL)
    }

    // listado de cuentas
    const accounts = () => {
      let accounts = JSON.parse(localStorage.getItem("storedAccounts"))
      console.log(JSON.parse(localStorage.getItem("storedAccounts")))
      console.log(accounts)
      
      if (accounts != null) {
        accountsHistory.value = accounts
        target.value = accountsHistory.value[0].login
        accounts.forEach((row) => {
          addTargetAccount(row.login, row.login)
        })
      }
    }
    function traslateLabel(platform_name){
      console.log(platform_name)
      if(platform_name=="The account has no history yet"){
        platform_name = i18n.global.t('accountActivity.nohistory');
        return platform_name
      }
    }

    const historyAccounst = (account_id, date_from = '', date_to = '', typeAccountDL) => {
      if (date_from == null && date_to == null) {
        date_from = '01/01/2021'
        date_to = '12/31/2021'
      } else if (date_from != null && date_to == null) {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }
        if (mm < 10) {
          mm = '0' + mm;
        }
        today = yyyy + '-' + mm + '-' + dd;
        date_to = today
      }

      userInfo = store.state.user
      rows.value = []
      showM.value = true
      paginatedData.value = []
      let _url = process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS + '/list' + typeAccountDL + '?account_id=' + account_id + '&date_from=' + date_from + '&date_to=' + date_to + '&type_transactions=2'
      let _headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + store.state.token,
        'X-Api-Key': process.env.VUE_APP_X_API_KEY
      }
      if (typeAccount.value != '' && platform.value != '' && target.value != null) {
        axios({ method: 'GET', url: _url, headers: _headers }).then((result) => {
          showM.value = false
          if (result.data.response.data != null && result.data.response.data.length > 0) {
            if (result.data.response.status === 'Success' && result.data.response.data != null && result.data.response.data.length > 0) {
              partialTrades1 = result.data.response.data
              rows.value = []
              partialTrades = []

              partialTrades1.forEach((row) => {
                /**** SUMAR TOTALES ******/
                // comissionTotalMt4.value += row.commission
                // swapTotal.value += row.swap
                // profitLoss.value += row.profit

                // let text1 = row.time;
                // let op_time_1 = text1.replace("T", " ");
                // let text2 = row.time;
                // let cl_time_1 = text2.replace("T", " ");

                rows.value.push([
                  row.ticket,
                  row.op_time,
                  row.type,
                  row.symbol,
                  row.size,
                  row.cl_price,
                  row.sl,
                  row.tp,
                  row.op_time,
                  row.cl_price,
                  row.commission,
                  row.swap,
                  row.profit
                ])
                partialTrades.push([
                  row.login,
                  row.platform,
                  row.ticket,
                  row.op_time,
                  row.type,
                  row.size,
                  row.symbol,
                  row.op_price,
                  row.sl,
                  row.tp,
                  row.cl_time,
                  row.cl_price,
                  row.commission,
                  row.swap,
                  row.profit,
                  row.comment
                ])
              })
              getTable(1)
            } else {
              // let message = result.data.message.data.cltrades == null ? result.data.message.message : 'INFO! No information available'
              emitter.emit('showDialog', traslateLabel(result.data.response.message))
            }
          }else {
            // let message = result.data.message.data.cltrades == null ? result.data.message.message : 'INFO! No information available'
            emitter.emit('showDialog', result.data.response.message)
          }

          /****lIMITAR 2 DECIMALES ******/
          // comissionTotalMt4.value = comissionTotalMt4.value.toFixed(2);
          // swapTotal.value = swapTotal.value.toFixed(2);
          // profitLoss.value = profitLoss.value.toFixed(2);

        }).catch((error) => {
          logger.error(error)
        })
      }else {
        showM.value = false
      }
    }

    const getTable = (page) => {
      getDataPages(page)
    }

    const getDataPages = (numberPage) => {
      totalPagesNumber.value = Math.ceil(rows.value.length / elementsForPage.value);
      currentPage.value = numberPage;
      paginatedData.value = [];
      let ini = (numberPage * elementsForPage.value) - elementsForPage.value;
      let fin = (numberPage * elementsForPage.value);
      paginatedData.value = rows.value.slice(ini, fin);
      for (var i in paginatedData.value) {
        paginatedData.value[i][9] = paginatedData.value[i][9].toFixed(2)
        paginatedData.value[i][5] = paginatedData.value[i][5].toFixed(2)
        paginatedData.value[i][12] = paginatedData.value[i][12].toFixed(2)
      }
    }

    const getPreviusPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--;
      }
      getDataPages(currentPage.value);
    }

    const getNextPages = () => {
      let totalP = Math.ceil(rows.value.length / elementsForPage.value);
      if (currentPage.value < totalP) {
        currentPage.value++;
      }
      getDataPages(currentPage.value);
    }

    const isActive = (numberPage) => {
      return numberPage == currentPage.value ? 'active' : '';
    }

    const generateCSV = () => {
      const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
      const header = Object.keys(partialTrades[0])
      const header2 = Object.keys(partialTrades1[0])
      const date = new Date().toISOString().substr(0, 10)
      const csv = [
        header2.join(','), // header row first
        ...partialTrades.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','))
      ].join('\r\n')

      download(csv, 'TradingHistory - ' + date + '.csv');
    }

    const download = (data, filename) => {
      if (!filename) { filename = 'export.csv'; }
      var blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
      if (!navigator.msSaveBlob) {
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blob);
      } else {
        navigator.msSaveBlob(blob, filename); // IE 10+
      }
    }

    const getRndInteger = (min, max) => {
      return Math.floor(Math.random() * (max - min)) + min;
    }

    const getAccountsType = () => {
      target.value = ""
      targets.value = []
      if (typeAccount.value == '' || typeAccount.value == null) {
        dialogMessage.value = this.$t('tradingHistory.errorTwo');
        showDialog.value = true;
        showM.value = false
        return false
      }else{
        rows.value = []
        paginatedData.value = []
        let callAccounts = ''
        if(typeAccount.value == 'demo' && platform.value == 'mt4'){
          callAccounts = localStorage.getItem("Accountsdm4")
        }else if(typeAccount.value == 'demo' && platform.value == 'mt5'){
          callAccounts = localStorage.getItem("Accountsdm5")
        }else if(typeAccount.value == 'live' && platform.value == 'mt4'){
          console.log("history lv mt4")
          callAccounts = localStorage.getItem("Accountslv4")
        }else if(typeAccount.value == 'live' && platform.value == 'mt5'){
          callAccounts = localStorage.getItem("Accountslv5")
          console.log("history lv mt5")
        }

        console.log(callAccounts)
        if (callAccounts == null || callAccounts == undefined || callAccounts == 'error') {
            showM.value = false;
        } else{
          callAccounts = JSON.parse(callAccounts)
          for (let i in callAccounts) {
              targets.value.push({
                value: callAccounts[i].login,
                text: callAccounts[i].login
              })
            }
        }
        /*let _url = process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS+'/list/'+platform.value+'check'+accountTyp+'accounts'

        let _headers = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + store.state.token,
          'X-Api-Key': process.env.VUE_APP_X_API_KEY
        }
        showM.value = true

        axios({ method: 'GET', url: _url, headers: _headers }).then((result) => {
          showM.value = false
          if (result.data.response.status == "Success") {
            let accountsDemo = result.data.response.data
            console.log(result.data.response.data);
            for (let i in accountsDemo) {
              targets.value.push({
                value: accountsDemo[i].login,
                text: accountsDemo[i].login
              })
            }
          }
        }).catch((error) => {
          showM.value = false
          logger.error(error)
        })*/
      }
    }

    watch(typeAccount, () => {
      if (platform.value != '') {
        getAccountsType()
      }
    })

    watch(
      platform, () => {
        if (platform.value != '') {
          getAccountsType()
        }
      }
    )

    return {
      status_user,
      typeAccountDemo,
      getDataPages,
      getPreviusPage,
      getNextPages,
      isActive,
      elementsForPage,
      getRndInteger,
      accounts,

      platform,
      platforms,
      based,
      basedOn,
      typeAccount,
      typeAccounts,

      deposit,
      withdrawal,
      credit,
      commision,
      swap,
      targets,
      target,
      dateFrom,
      dateTo,
      rows,
      headers,
      loadTable,
      getData,
      paginatedData,
      back,
      accountsHistory,
      reloadTable,
      // comissionTotalMt4,
      // swapTotal,
      // profitLoss,
      totalPagesNumber,
      getTable,
      partialTrades1,
      partialTrades,
      generateCSV,
      download,
      showM,
      dialogMessage,
      showDialog
    }
  }
}
</script>

<style scoped>
</style>
